import React from "react";
import * as R from "ramda";
import CSSModules from "react-css-modules";
import { connect } from "react-redux";

import { Div, BigFilledButton, BigOutlineButton } from "components/Base";

import { actions, getters } from "../model";
import styles from "./styles.scss";

import { noop } from "utils/General";

import { getBackgroundColor } from "Portal/NewPortal/PortalHome/selectors";
import { isFormValid } from "../selectors";

import { FloatingSaveBar } from "EventLight/Common/FieldLayout";
import UnsavedChangesModal from "./UnsavedChangesModal";

import { Mobile, Default } from "Portal/NewPortal/Shared/MediasQuery";

const decorate = R.compose(
  connect(
    state => ({
      backgroundColor: getBackgroundColor(state),
      saving: getters.saving(state),
      isValid: isFormValid(state),
      hasUnSavedChangesModal: getters.hasUnSavedChangesModal(state)
    }),
    {
      save: actions.save,
      onCancel: actions.cancel
    }
  ),
  CSSModules(styles)
);

const Body = ({
  isValid = true,
  save = noop,
  onCancel = noop,
  backgroundColor,
  hasUnSavedChangesModal,
  saving
}) => {
  return (
    <>
      <FloatingSaveBar
        styles={{
          background: backgroundColor,
          display: "fixed",
          width: "100%",
          zIndex: 3
        }}
      >
        <Default>
          <Div display="row.flex-start.center">
            <BigOutlineButton
              disabled={saving}
              width={100}
              onClick={onCancel}
              mr={3}
            >
              Cancel
            </BigOutlineButton>
            <BigFilledButton
              onClick={save}
              data-cy="event-details-save-button"
              disabled={saving || isValid !== true}
              className="accentable-primary-button"
            >
              {saving ? "Saving..." : "Save Changes"}
            </BigFilledButton>
            {isValid !== true ? (
              <Div fs={1} color="gray7">
                {isValid}
              </Div>
            ) : null}
          </Div>
        </Default>
        <Mobile>
          <Div
            display="column.center.center"
            style={{ gap: "8px", width: "100%", padding: "10px" }}
          >
            <BigFilledButton
              bg="#4263EB"
              color="white"
              onClick={save}
              data-cy="event-details-save-button"
              width={1}
              height={36}
              disabled={saving || isValid !== true}
            >
              {saving ? "Saving..." : "Save Changes"}
            </BigFilledButton>
            <BigOutlineButton
              width={1}
              onClick={onCancel}
              height={36}
              disabled={saving}
            >
              Cancel
            </BigOutlineButton>

            {isValid !== true ? (
              <Div fs={1} color="gray7">
                {isValid}
              </Div>
            ) : null}
          </Div>
        </Mobile>
      </FloatingSaveBar>
      {hasUnSavedChangesModal && <UnsavedChangesModal />}
    </>
  );
};

export default decorate(Body);
